import React from "react";
import ContactButton from './ContactButton';
import CarruselInstituciones from "./CarruselInstituciones";

const Hero: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-white">
      <div className="mx-auto max-w-7xl px-6 py-20 md:py-28 lg:py-32 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 shadow-sm">
          <span className="inline-block h-4 w-4 rounded-full border border-slate-300 grid place-items-center">
            <svg
              className="h-3 w-3"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M20 7l-8-4-8 4 8 4 8-4z" />
              <path d="M4 7v10l8 4 8-4V7" />
              <path d="M12 11v10" />
            </svg>
          </span>
          <span className="font-medium">Desarrollo</span>
        </div>

        {/* Heading */}
        <h1 className="mt-8 text-4xl font-extrabold leading-[1.1] tracking-tight text-slate-900 sm:text-5xl md:text-6xl">
          Haz crecer tu negocio con
          <br className="hidden sm:block" />
          tecnología a tu medida
        </h1>

        {/* Subtitle */}
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-600">
          En LEXIS desarrollamos soluciones de software innovadoras y escalables,
          que crecen junto a tu empresa.
        </p>

        {/* CTA */}
        <div className="mt-10">
          <ContactButton variant="secondary" className="rounded-xl font-semibold" />
        </div>

        <CarruselInstituciones />

        {/* Imagen publicitaria */}
        <div className="mt-10 relative min-h-[600px] rounded-xl overflow-hidden group cursor-pointer shadow-lg hover:shadow-2xl transition-all duration-500">
          <img 
            src="/image_hero.png" 
            alt="image_hero" 
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" 
          />
          {/* iPhone Pro Hero */}
          <img 
            src="/iPhone_Pro_hero.png" 
            alt="iPhone_Pro_hero" 
            className="absolute bottom-0 md:left-[20px] lg:left-[60px] h-[550px] z-10" 
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
